<template>
  <div id="app">
    <Intro v-if=intro @end=closeIntro />
    <div v-else>
      <header class="d-flex">
        <span class="flex-1" @click="showState">
          {{ state }}
          <input v-if="!hideState" v-model="newState" @keyup.enter="setState" @blur="setState">
        </span>
        <span class="menu" :class="{hide: !showMenu}">
          <span class="button text-medium cursor-pointer" :class="{selected: mode === 'index'}" @click="setMode('index')">소개</span>
          <span class="button text-medium cursor-pointer" :class="{selected: mode === 'mission'}" @click="setMode('mission')">미션</span>
          <span class="button text-medium cursor-pointer" :class="{selected: mode === 'player'}" @click="setMode('player')">플레이어</span>
          <span class="button text-medium cursor-pointer" :class="{selected: mode === 'prize'}" @click="setMode('prize')">상품</span>
        </span>
        <span class="toggleMenu" :class="{close: showMenu}" @click="showMenu = !showMenu">
          <div></div>
          <div></div>
          <div></div>
        </span>
      </header>
      <div class="container d-flex" style="height: calc(100vh - 56px); overflow: hidden;">
        <main class="flex-1" style="overflow-y: auto;">
          <transition name=fade>
            <Index v-if="mode === 'index'" @auth=auth />
          </transition>
          <transition name=fade>
            <Mission v-show="mode === 'mission'" :mission=mission :permission=permission :players=players />
          </transition>
          <transition name=fade>
            <Player v-show="mode === 'player'" :players=players :team=team :permission=permission />
          </transition>
          <transition name=fade>
            <Prize v-show="mode === 'prize'" :prize=prize :players=players />
          </transition>
        </main>
        <Rank ref=rank :players=players :team=team />
      </div>
    </div>
    <transition name=fade>
      <Auth v-show=showAuth :user=user @close="showAuth = false" />
    </transition>
    <Roulette ref=roulette :players=players :permission=permission />
    <img
      class="roulette cursor-pointer"
      v-if="permission === 'master' || permission === 'manager'"
      src="/static/img/roulette/bg_circle8.png"
      @click="$refs.roulette.hide = !$refs.roulette.hide"
    >
  </div>
</template>

<script>
import Intro from './components/Intro'
import Index from './components/Index'
import Mission from './components/Mission/'
import Player from './components/Player'
import Prize from './components/Prize'
import Rank from './components/Rank'
import Auth from './components/Auth'
import Roulette from './components/Roulette'

import snapshot from './assets/snapshot.js'

export default {
  name: 'app',
  components: {
    Intro,
    Index,
    Mission,
    Player,
    Prize,
    Rank,
    Auth,
    Roulette
  },
  data: () => ({
    user: null,
    intro: process.env.NODE_ENV === 'production',
    showAuth: false,
    showMenu: false,
    showRoulette: true,
    roulette: false,
    state: 'Loading ...',
    hideState: true,
    newState: null,
    mode: process.env.NODE_ENV === 'production' ? 'index' : 'mission',
    players: null,
    team: null,
    red: [],
    blue: [],
    prize: null,
    mission: null
  }),
  computed: {
    permission () {
      return this.user && this.user.permission
    }
  },
  mounted () {
    window.onbeforeunload = () => { return false }
    this.$socket.client.emit('load')
    this.loadSnapshot()
  },
  methods: {
    loadSnapshot () {
      const data = snapshot

      this.state = data.state
      this.players = data.players
      this.red = data.team.red.players
      this.blue = data.team.blue.players
      this.prize = data.prize
      this.mission = data.mission
      this.update()
    },
    update () {
      let players = [...this.players]
      players.forEach(p => {
        p.score = 0
      })

      this.mission.forEach(m => {
        if (!m.winner || !m.winner.length) return

        m.winner.forEach((w, i) => {
          const user = this.players.find(p => p.id === w)

          if (!user) return

          if (m.scores[i]) {
            user.score += m.scores[i]
          }
        })
      })

      players = players.sort((a, b) => a.score < b.score ? 1 : a.score > b.score ? -1 : 0)

      players.forEach((p, i) => {
        p.rank = i + 1
      })

      const red = this.red
        .map(i => typeof i === 'string' ? this.players.find(p => i === p.id) : i)
        .sort((a, b) => a.score < b.score ? 1 : a.score > b.score ? -1 : 0)

      red.forEach(p => {
        p.team = 'red'
      })

      const blue = this.blue
        .map(i => typeof i === 'string' ? this.players.find(p => i === p.id) : i)
        .sort((a, b) => a.score < b.score ? 1 : a.score > b.score ? -1 : 0)

      blue.forEach(p => {
        p.team = 'blue'
      })

      const team = {
        red: {
          players: red,
          score: red.reduce((acc, cur) => acc + cur.score, 0)
        },
        blue: {
          players: blue,
          score: blue.reduce((acc, cur) => acc + cur.score, 0)
        }
      }

      // this.players = players

      this.players.forEach((p, i) => {
        if (!players.some(player => player.id === p.id)) {
          this.players.splice(i, 1)
        }
      })
      players.forEach(p => {
        if (!this.players.some(player => player.id === p.id)) {
          this.players.push(p)
        }
        const player = this.players.find(player => player.id === p.id)

        if (!player) return

        player.rank = p.rank
        player.score = p.score
        player.team = p.team
      })

      setTimeout(() => {
        this.players = this.players.sort((a, b) => a.score < b.score ? 1 : a.score > b.score ? -1 : 0)
      }, 100)

      this.team = team
    },
    closeIntro () {
      this.intro = false
      this.$nextTick(() => {
        this.mode = 'index'
      })
    },
    setMode (mode) {
      this.$refs.rank.hide = true
      if (this.mode === mode) return
      if (this.mode === '') {
        this.mode = mode
      } else {
        this.mode = ''
        setTimeout(() => {
          this.mode = mode
        }, 500)
      }
      this.showMenu = false
    },
    auth () {
      this.showAuth = true
    },
    showState () {
      if (!['master', 'manager'].includes(this.permission)) return
      this.hideState = false
    },
    setState () {
      if (!['master', 'manager'].includes(this.permission)) return
      if (!this.newState || !this.newState.length) return
      this.$socket.client.emit('updateState', this.newState)
      this.hideState = true
    }
  },
  sockets: {
    load (data) {
      this.state = data.state
      this.players = data.players
      this.red = data.team.red.players
      this.blue = data.team.blue.players
      this.prize = data.prize
      this.mission = data.mission
      this.update()
    },
    whoami (data) {
      this.user = data
    },
    addUser (data) {
      this.players.push(data)
      this.$data[data.team].push(data.id)
      this.update()
    },
    updateUser (data) {
      const match = this.players.find(i => i.id === data.id)
      if (match) {
        Object.assign(match, data)
      } else {
        this.addUser(data)
      }
      this.update()
    },
    removeUser (data) {
      this.players = this.players.filter(i => i.id !== data.id)
      this.red = this.red.filter(i => i !== data.id)
      this.blue = this.blue.filter(i => i !== data.id)
      this.update()
    },
    updateTeam (data) {
      this.red = data.red.players
      this.blue = data.blue.players
      this.update()
    },
    updateMission (data) {
      const match = this.mission.find(m => m.code === data.code)
      if (!match) return
      Object.assign(match, data)
      this.update()
    },
    updateCompleted (data) {
      const match = this.mission.find(m => m.code === data.code)
      if (!match) return
      match.completed = data.completed
    },
    updateWinner (data) {
      console.log('sockets.updateWinner', data)
      const match = this.mission.find(m => m.code === data.code)
      if (!match) return
      console.log('match', match)
      match.winner[data.index] = data.winner
      this.update()
    },
    updateState (data) {
      this.state = data.state
    }
  }
}
</script>

<style>
body {
  margin: 0;
}

#app {
  font-family: Inter, Roobert, "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

main {
  text-align: center;
}

header {
  margin: 0;
  height: 56px;
  padding: 0 16px 0 24px;
  background-color: #dab3f2;
  color: #ffffff;
}

header span {
  position: relative;
  font-size: 20px;
  line-height: 1;
  letter-spacing: .02em;
  font-weight: 400;
  box-sizing: border-box;
  padding-top: 16px;
}

a {
  text-decoration: none;
  color: inherit;
}

.v-list-item span.red {
  color: #6d2321;
  font-weight: 800;
}
.v-list-item span.blue {
  color: #4b5b76;
  font-weight: 800;
}
.v-list-item.red {
  background: #ffdad8;
}
.v-list-item:hover.red {
  background: #ffbcba;
}
.v-list-item.blue {
  background: #e1ecff;
}
.v-list-item:hover.blue {
  background: #c5daff;
}
.transition-800ms {
  transition: all .8s ease-in-out;
}
</style>

<style scoped>
header .button {
  margin: 0 1em;
  line-height: 1.5;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease-in-out;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.toggleMenu {
  display: none;
}
.toggleMenu>div {
  display: block;
  margin-bottom: 5px;
  width: 30px;
  height: 4px;
  background-color: white;
  border-radius: 2px;
  transition: all .3s ease-in-out;
}
.toggleMenu.close>div:first-child {
  transform: translate(0, 9px) rotate(45deg);
}
.toggleMenu.close>div:nth-child(2) {
  opacity: 0;
}
.toggleMenu.close>div:last-child {
  transform: translate(0, -9px) rotate(-45deg);
}
.roulette {
  position: fixed;
  left: 10px;
  bottom: 10px;
  width: 30px;
  height: 30px;
}
@media screen and (max-width: 1080px) {
main {
  margin-right: 50px;
}
.menu {
  position: fixed;
  top: 66px;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: right;
  background-color: #dab3f2;
  z-index: 20;
  transition: all .3s;
}
.menu.hide {
  transform: translateX(100vw);
}
.menu>span {
  display: block;
}
.toggleMenu {
  display: block;
}
}
</style>



// WEBPACK FOOTER //
// src/App.vue